import Button from 'react-bootstrap/Button'

export default function ReportRefreshButton({
  onRefresh,
  isRefreshing = false,
  disabled = false,
  className = '',
  testId = 'report-refresh-button',
  size = 'default',
}) {
  if (!onRefresh) return null

  const isDisabled = disabled || isRefreshing

  return (
    <Button
      variant="outline-light"
      className={`icon-button btn-refresh form-control-height d-flex align-items-center gap-2 px-4 ${className}`.trim()}
      data-testid={testId}
      disabled={isDisabled}
      onClick={onRefresh}
      aria-busy={isRefreshing}
      aria-label={isRefreshing ? 'Refreshing report' : 'Refresh report'}
      style={
        size === 'compact'
          ? undefined
          : {
              borderRadius: '20px',
              borderColor: '#e6e8ec',
              color: '#121923',
              fontWeight: '600',
            }
      }
    >
      <span>{isRefreshing ? 'Refreshing…' : 'Refresh'}</span>
    </Button>
  )
}
